<div>
    <h3 class="webapp-pre-title">{{sectionInfo.category}}</h3>
    <h1 class="webapp-title margin-top-md" #visado>{{sectionInfo.title}}</h1>

    <img [src]="sectionInfo.imageUrl" alt="Que es el visado de estudiantes para Europa" class="single-cover-image">
    <span *ngIf="sectionInfo.categories">
      <span class="card-category" *ngFor="let cat of sectionInfo.categories">{{cat}}</span>
    </span>
    <div class="single-post-content">

      <app-smart-paragraph *ngIf="sectionInfo.shortPara" [text]="sectionInfo.shortPara" [limit]="200"></app-smart-paragraph>
      <app-smart-paragraph *ngIf="sectionInfo.longPar" [text]="sectionInfo.longPar" [limit]="200"></app-smart-paragraph>
      <app-smart-paragraph *ngIf="sectionInfo.text" [text]="sectionInfo.text" [limit]="200"></app-smart-paragraph>
      <app-smart-paragraph *ngIf="sectionInfo.description" [text]="sectionInfo.description" [limit]="200"></app-smart-paragraph>
    
      <div *ngIf="sectionInfo.paragraphsWithIcons">
        <div class="list detailed-list list-dividers">
          <ul>
              <li *ngFor="let item of sectionInfo.array">
                  <span class="item-link item-content">
                      <div [class]="getItemCntClass(sectionInfo)">
                          <i [class]="getItemClass(sectionInfo,item)"></i>
                      </div>
                      <div class="item-inner">
                        <div>
                            <div class="item-name">{{item.title}}</div>
                            <!-- <div class="item-footer">{{item.description}}</div> -->
                            <div class="item-footer">
                              <app-smart-paragraph [text]="item.description" [limit]="100"></app-smart-paragraph>
                            </div>
                        </div>
                      </div>
                  </span>
              </li>
          </ul>
        </div>
      </div>

      <span *ngFor="let obj of sectionInfo.array">
        <h2 class="webapp-title-secondary">{{obj.subtitle}}</h2>
        <p>{{obj.text}}</p>
      </span>
    </div>
</div>
